/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { webApi } from "../../../lib/WebApi"
import { statAdminEvent } from "../../../util/analytics"

export const LOAD_STAFF_STARTED = "LOAD_STAFF_STARTED"
export function loadStaffStarted() {
    return {
        type: LOAD_STAFF_STARTED,
    }
}

export const LOAD_STAFF_SUCCEEDED = "LOAD_STAFF_SUCCEEDED"
export function loadStaffSucceeded(users) {
    users.forEach(
        (user) =>
            (user.full_name = user.last_name
                ? `${user.first_name} ${user.last_name}`
                : user.first_name)
    )
    users.sort((user1, user2) => user1.full_name.localeCompare(user2.full_name))
    return {
        type: LOAD_STAFF_SUCCEEDED,
        users: users,
    }
}

export const LOAD_STAFF_FAILED = "LOAD_STAFF_FAILED"
export function loadStaffFailed() {
    return {
        type: LOAD_STAFF_FAILED,
    }
}

export function loadStaff() {
    return function (dispatch) {
        dispatch({
            type: "COMMON_SET",
            key: "division_staff",
            value: {
                complete: false,
            },
            note: "division staff needs reload",
        })

        /*
        dispatch(loadStaffStarted());
        dispatch(loadStaffRequest((err, users) => {
            if (err) {
                dispatch(loadStaffFailed());
            } else {
                dispatch(loadStaffSucceeded(users));
            }
        }));
        */
    }
}

export function loadStaffByDivision(divisionId, callback) {
    return function (dispatch) {
        // dispatch({
        //     type: 'COMMON_SET',
        //     key: 'division_staff',
        //     value: {
        //         complete: false
        //     },
        //     note: 'division staff needs reload'
        // })
        dispatch(loadStaffStarted())
        dispatch(
            loadStaffByDivisionRequest(divisionId, (err, users) => {
                if (err) {
                    dispatch(loadStaffFailed())
                } else {
                    if (typeof callback === "function") {
                        callback(users)
                    }
                    dispatch(loadStaffSucceeded(users))
                }
            })
        )
    }
}

export function inviteStaff(divisionId, emails, callback) {
    return function (dispatch) {
        dispatch(
            inviteToDivisionRequest(divisionId, emails, (err) => {
                statAdminEvent(divisionId, "invite-request", "members")
                dispatch(loadStaffByDivision(divisionId, callback))
            })
        )
    }
}

export function deleteStaffFromDivision(divisionMemberId, divisionId) {
    return (dispatch) => {
        dispatch(
            deleteStaffFromDivisionRequest(divisionMemberId, (err) => {
                statAdminEvent(divisionId, "delete-from-division", "members")
                dispatch(loadStaffByDivision(divisionId))
            })
        )
    }
}

export function inviteToDivisionRequest(divisionId, emails, callback) {
    return (dispatch) => {
        return webApi
            .inviteMembersToDivision(divisionId, emails)
            .then(
                () => callback(),
                (error) => callback(error)
            )
            .catch((err) => callback(err))
    }
}

export function addAsCoachRequest(teamId, email, callback) {
    return (dispatch) => {
        return webApi
            .addMemberAsCoach(teamId, email)
            .then(
                () => callback(),
                (error) => callback(error)
            )
            .catch((err) => callback(err))
    }
}

export function loadTeamsRequestByDivision(divisionId, callback) {
    return (dispatch) => {
        return webApi.getDivisionTeams(divisionId)
            .then(teams => callback(teams), error => callback(new Error(error)))
            .catch(err => callback(err))
    }
}

export function deleteStaffFromDivisionRequest(divisionMemberId, callback) {
    return (dispatch) => {
        return webApi
            .deleteMemberFromDivision(divisionMemberId)
            .then(
                () => callback(),
                (error) => callback(error)
            )
            .catch((err) => callback(err))
    }
}

export function updateStaffInDivision(userId, userData, divisionId) {
    return (dispatch) => {
        dispatch(
            updateStaffRequest(userId, userData, (err) => {
                statAdminEvent(divisionId, "update-user", "members")
                dispatch(loadStaffByDivision(divisionId))
            })
        )
    }
}

export function updateStaffRequest(userId, userData, callback) {
    return (dispatch) => {
        return webApi
            .updateUser(userId, userData)
            .then(
                () => callback(),
                (error) => callback(error)
            )
            .catch((err) => callback(err))
    }
}

export function loadStaffByDivisionRequest(divisionId, callback) {
    return (dispatch) => {
        return webApi
            .getDivisionUsers(divisionId)
            .then(
                (users) => callback(null, users),
                (error) => callback(new Error(error))
            )
            .catch((err) => callback(err))
    }
}

export function loadStaffRequest(callback) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            callback(null, [
                {
                    first_name: "John",
                    last_name: "Doe",
                    email: "john_doe@gmail.com",
                    user_id: -11,
                },
                {
                    first_name: "Samantha",
                    last_name: "Smith",
                    email: "smithy@gmail.com",
                    user_id: -12,
                },
                {
                    first_name: "Harry",
                    last_name: "Potter",
                    email: "pottery@gmail.com",
                    user_id: -13,
                },
            ])
            resolve()
        })
    }
}
